/* eslint-disable react-refresh/only-export-components */
import { FC, lazy, LazyExoticComponent } from 'react';

import { routingConfig } from '../../consts';
import { RouteWithComponent } from '../../interfaces';

const CertificateList: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/certificateList/certificateList.component')
);
const CertificatePath: LazyExoticComponent<FC> = lazy(
  (): Promise<{ default: FC }> => import('./components/certificatePath/certificatePath.component')
);

export const certificatesRoutes: RouteWithComponent[] = [
  { pathSettings: routingConfig.certificates.children.certificates, component: CertificateList },
  { pathSettings: routingConfig.certificates.children.certificatePath, component: CertificatePath },
];
